import s from './Selectors.module.scss';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { AnimatePresence, motion } from 'framer-motion';
import { SetStateAction, useMemo, useState } from 'react';
import {
    MydataOpts,
    MydataProduct,
    MydataQuestion,
    MydataResponse,
    SelectOpt,
} from '../../../types';
import { useLoaderData } from 'react-router-dom';
import { ReactComponent as VortexSVG } from '../../../aassets/ic/ui/ic_vortex.svg';

interface Props {
    opts: MydataOpts;

    prodState: SelectOpt | undefined;
    domState: SelectOpt | undefined;
    catState: SelectOpt | undefined;
    subjState: SelectOpt | undefined;
    lvlState: SelectOpt | undefined;

    handleProdChange: (value: any) => void;
    handleDomChange: (value: any) => void;
    handleCatChange: (value: any) => void;
    handleSubjChange: (value: any) => void;
    handleLvlChange: (value: any) => void;
}
const Selectors = ({
    opts,
    prodState,
    domState,
    catState,
    subjState,
    lvlState,
    handleProdChange,
    handleDomChange,
    handleCatChange,
    handleSubjChange,
    handleLvlChange,
}: Props) => {
    const animatedComponents = makeAnimated();
    const { products, domains, categories, subjects, levels } = opts;

    return (
        <section className={s.rt}>
            <div className={s.top}>
                <VortexSVG />
                <span>סינון לפי:</span>
            </div>
            <div className={s.selects}>
                <div className={s.md_wrap}>
                    <motion.div
                        className={s.md}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <Select
                            placeholder="בחר יחידה"
                            value={prodState ?? null}
                            onChange={handleProdChange}
                            options={products}
                            components={animatedComponents}
                        />
                    </motion.div>
                </div>
                <div className={s.md_wrap}>
                    {prodState && (
                        <motion.div
                            className={s.md}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <Select
                                placeholder="בחר תחום"
                                value={domState ?? null}
                                onChange={handleDomChange}
                                options={domains[prodState.value] ?? undefined}
                                components={animatedComponents}
                            />
                        </motion.div>
                    )}
                </div>
                <div className={s.md_wrap}>
                    {prodState && domState && (
                        <motion.div
                            className={s.md}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <Select
                                placeholder="בחר קטגוריה"
                                value={catState ?? null}
                                onChange={handleCatChange}
                                options={
                                    Object.hasOwn(
                                        categories,
                                        prodState.value
                                    ) &&
                                    Object.hasOwn(
                                        categories[prodState.value],
                                        domState.value
                                    )
                                        ? categories[prodState.value][
                                              domState.value
                                          ]
                                        : undefined
                                }
                                components={animatedComponents}
                            />
                        </motion.div>
                    )}
                </div>
                <div className={s.md_wrap_lvl}>
                    {prodState && domState && catState && (
                        <motion.div
                            className={s.md}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <Select
                                placeholder="קושי"
                                value={lvlState ?? null}
                                onChange={handleLvlChange}
                                options={
                                    levels[prodState.value][catState.value] ??
                                    undefined
                                }
                                components={animatedComponents}
                            />
                        </motion.div>
                    )}
                </div>
                <div className={s.md_wrap}>
                    {prodState && domState && catState && (
                        <motion.div
                            className={s.md}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                        >
                            <Select
                                placeholder="בחר נושא"
                                value={subjState ?? null}
                                onChange={handleSubjChange}
                                options={
                                    Object.hasOwn(subjects, prodState.value) &&
                                    Object.hasOwn(
                                        subjects[prodState.value],
                                        catState.value
                                    )
                                        ? subjects[prodState.value][
                                              catState.value
                                          ]
                                        : undefined
                                }
                                components={animatedComponents}
                            />
                        </motion.div>
                    )}
                </div>
            </div>
        </section>
    );
};
export default Selectors;
